import { render, staticRenderFns } from "./panelAddons.vue?vue&type=template&id=0f067437&scoped=true&lang=pug"
import script from "./panelAddons.vue?vue&type=script&lang=js"
export * from "./panelAddons.vue?vue&type=script&lang=js"
import style1 from "./panelAddons.vue?vue&type=style&index=1&id=0f067437&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f067437",
  null
  
)

export default component.exports